import { createTheme } from '@mui/material';

const theme = createTheme({
  typography: { fontFamily: 'Inter, sans-serif' },
  shape: { borderRadius: 4 },
  palette: {
    // Note: MUI palette requires hex values for internal color calculations
    // Component overrides below can still use CSS vars
    border: {
      normal: '#DDE2E9', // --color-neutral-5
    },
    grey: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      25: '#FAFBFC', // --color-neutral-1
      50: '#FAFBFC', // --color-neutral-1
      100: '#F5F7F9', // --color-neutral-2
      200: '#EFF2F5', // --color-neutral-3
      300: '#DDE2E9', // --color-neutral-5
      400: '#C2CBD7', // --color-neutral-6
      500: '#9BA8BB', // --color-neutral-7
      600: '#6B7C95', // --color-neutral-8
      700: '#4F5F78', // --color-neutral-9
      800: '#3B4A60', // --color-neutral-10
      900: '#101622', // --color-neutral-13
      A100: '#DDE2E9', // --color-neutral-5
      A200: '#DDE2E9', // --color-neutral-5
      A400: '#4F5F78', // --color-neutral-9
      A700: '#2B3749', // --color-neutral-11
    },
    primary: {
      50: '#F5F7ED', // --color-brand-1
      100: '#EAEEDD', // --color-brand-2
      200: '#CFD9AD', // --color-brand-3
      300: '#B7BF99', // --color-brand-4
      400: '#919973', // --color-brand-5
      500: '#798844', // --color-brand-7
      main: '#667239', // --color-brand-6
      600: '#667239', // --color-brand-6
      700: '#5B6633', // --color-brand-8
      800: '#3D4422', // --color-brand-9
      900: '#1E2211', // --color-brand-10

      light: '#B7BF99', // --color-brand-4
      dark: '#3D4422', // --color-brand-9
      contrastText: '#FFFFFF', // --color-white
    },
    secondary: {
      main: '#798844', // --color-brand-7
    },
    background: {
      default: '#FFFFFF', // --color-white
      paper: '#FFFFFF', // --color-white
    },
    error: {
      light: '#ffe5e5', // --color-red-bg
      main: '#c92a2a', // --color-red-text
      dark: '#951D1D',
    },
    info: {
      main: '#1971c2', // --color-blue-text
    },
    action: {
      active: 'rgba(9, 24, 66, 0.54)', // --color-neutral-alpha-8
    },
    warning: {
      light: '#fff4e6', // --color-orange-bg
      main: '#e8590c', // --color-orange-text
      dark: '#604A00',
    },
    text: {
      primary: '#101622', // --color-neutral-text
      secondary: '#4F5F78', // --color-neutral-9
      disabled: '#6B7C95', // --color-neutral-8
    },
  },
  breakpoints: { values: { xs: 600, sm: 900, md: 1200, lg: 1980, xl: 3440 } },
  components: {
    MuiCard: {
      styleOverrides: { root: { boxShadow: 'none', border: '1px solid var(--color-neutral-5)', borderRadius: '10px' } },
    },
    MuiChip: {
      styleOverrides: {
        root: { color: 'var(--color-neutral-text)', background: 'var(--color-neutral-alpha-4)' },
        colorSuccess: { color: 'var(--color-green-text)', background: 'var(--color-green-bg)' },
        colorWarning: { color: 'var(--color-orange-text)', background: 'var(--color-orange-bg)' },
        colorError: { color: 'var(--color-red-text)', background: 'var(--color-red-bg)' },
      },
    },
    MuiButton: { styleOverrides: { outlined: { '&:hover': { backgroundColor: 'var(--color-brand-1)' } } } },
  },
});

export default theme;
